module.exports = __webpack_public_path__ + "static/media/11-RotHeatExchanger - DX cool - No heat.b68864e0.png";